<template>
  <v-sheet v-if="showBar" class="d-flex align-center flex-wrap ga-6 px-3 py-1" rounded border>
    <product-epeat-label v-if="labels?.epeat?.certified" :level="labels.epeat.level || undefined" />
    <div v-if="hasEprelInfo" class="d-flex align-center ga-2">
      <img
        v-if="labels?.eprel?.badgeUrl"
        :src="labels.eprel.badgeUrl"
        :alt="$t('eprel.energyEfficiency')"
        height="28"
      />

      <sf-link v-if="hasEprelDialogContent" href="#" @click.prevent="showEprelDialog = true">
        {{ $t('eprel.energyEfficiency') }}
      </sf-link>
    </div>
    <product-charger-label :charger-info="labels?.charger" />
  </v-sheet>

  <product-eprel-dialog v-model="showEprelDialog" :eprel-info="labels?.eprel" />
</template>

<script setup lang="ts">
import SfLink from '@/components/text/SfLink.vue'
import ProductChargerLabel from '@/modules/product/components/ProductChargerLabel.vue'
import ProductEpeatLabel from '@/modules/product/components/ProductEpeatLabel.vue'
import ProductEprelDialog from '@/modules/product/components/ProductEprelDialog.vue'
import { Labels } from '@/types/index'
import { computed, ref } from 'vue'

const props = defineProps<{
  labels?: Labels | null
}>()

const showEprelDialog = ref(false)

const hasEprelBadge = computed(() => {
  return !!props.labels?.eprel?.badgeUrl
})

const hasEprelDialogContent = computed(() => {
  return !!props.labels?.eprel?.labelUrl || !!props.labels?.eprel?.datasheetUrl
})

const hasEprelInfo = computed(() => {
  return hasEprelBadge.value || hasEprelDialogContent.value
})

const hasChargerLabel = computed(() => {
  return (
    !!props.labels?.charger?.chargerIncludedUrl || !!props.labels?.charger?.chargerInformationUrl
  )
})

const showBar = computed(() => {
  return !!props.labels?.epeat?.certified || hasEprelInfo.value || hasChargerLabel.value
})
</script>
